module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACqSURBVHgBfZENEcIwDIVXFMwBQwGTUAmTMAmVgAQcgAPmYKAAHBQUbA7C6y67vWU/7+67Nklfm0tdZiQiHksJzpr6gcY598nWBEMBWpkUwZviWzqzZopk8Du1go2Rbq5BBTrNlyBQvR1Nlcx1NC03+irLH+B9gp46P4EXxV+QU9xrbnh10Yq2XOv+QfVgB3ShYtTLArXdLUxmgneZDysZrmK/Yks4mCe26n/iACKRm8LougAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/pri_viewicon.png
// module id = 2047
// module chunks = 1